import { render, staticRenderFns } from "./RegisterWelcome.vue?vue&type=template&id=6201e17a&"
import script from "./RegisterWelcome.vue?vue&type=script&lang=js&"
export * from "./RegisterWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports